import React, {Component} from "react";
import SimpleInput from "../../../../modules/SimpleInput";

class EkspedisiDetailContentInput extends Component {
    render() {
        return (
            <>
                <div style={{marginBottom: "20px"}}>
                    <div className="grid grid-3x gap-20px grid-mobile-none">
                        <div id="grid-1">
                            <SimpleInput
                                id="input_text_kode_cabang"
                                name="kodeCabang"
                                label="Cabang"
                                readOnly
                                value={this.props.dataHeader?.kodeCabang?.namaDealer}
                            />
                            <SimpleInput
                                id="input_text_no_pdi"
                                name="pdiNo"
                                label="No. PDI"
                                readOnly
                                value={this.props.dataHeader?.pdiNo}
                            />
                            <SimpleInput
                                id="input_text_no_ekspedisi"
                                name="expeditionNumber"
                                label="No. Ekspedisi"
                                readOnly
                                value={this.props.dataHeader?.expeditionNo}
                            />
                        </div>
                        <div id="grid-2">
                            <SimpleInput
                                id="input_text_type_unit"
                                name="typeUnit"
                                label="Tipe Unit"
                                readOnly
                                value={this.props.dataHeader?.tipeUnit}
                            />
                            <SimpleInput
                                id="input_text_warna_unit"
                                name="warnaUnit"
                                label="Warna Unit"
                                readOnly
                                value={this.props.dataHeader?.warnaUnit}
                            />
                            <SimpleInput
                                id="input_text_no_mesin"
                                name="engineNumber"
                                label="No. Mesin"
                                readOnly
                                value={this.props.dataHeader?.engineNumber}
                            />
                        </div>
                        <div id="grid-3">
                            <SimpleInput
                                id="input_text_no_fj"
                                name="fjNo"
                                label="No. FJ"
                                readOnly
                                value={this.props.dataHeader?.noFakturJual}
                            />
                            <SimpleInput
                                id="input_text_no_rangka"
                                name="frameNumber"
                                label="Np. Rangka"
                                readOnly
                                value={this.props.dataHeader?.frameNumber}
                            />
                            <SimpleInput
                                id="input_text_nama_pembeli"
                                name="buyerName"
                                label="Nama Pembeli"
                                readOnly
                                value={this.props.dataHeader?.buyerName}
                            />
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default EkspedisiDetailContentInput;